// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2Z-jx","actionsCol":"EnrolledClinics_actionsCol__1oruT"};